import React from 'react';
import { ChartYlabelProps } from './chart-y-label.props';
import './chart-y-label.scss';

export const ChartYLabel: React.FC<ChartYlabelProps> = (props) => {
  const labels: Array<number> = [];

  const createLabels = () => {
    const content = Math.round(100 / props.levels);

    for (let i = 0; i < props.levels; i++) {
      labels.push(content * i);
    }
    labels.shift();
  };

  createLabels();

  return (
    <>
      <div className="sg-chart__labels">
        <span>pctl. <br /> top</span>
        {labels.map((text, i) => <span key={i}>{text}</span>)}
        <span>bottom</span>
      </div>
    </>
  );
};
